export default "__VITE_ASSET__CdAXK4CB__"